<template>
  <div class="view">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'company', params: {} }">
        Company
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'companyView', params: {} }">
        View Company
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card v-if="loaded">
      <v-card-title> View Company </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr v-if="company.name">
                <td max-width="35%" class="text-subtitle-1">Name:</td>
                <td>{{ company.name }}</td>
              </tr>
              <tr v-if="company.thaiName">
                <td max-width="35%" class="text-subtitle-1">Thai Name:</td>
                <td>{{ company.thaiName }}</td>
              </tr>
              <tr v-if="company.chineseName">
                <td max-width="35%" class="text-subtitle-1">Chinese Name:</td>
                <td>{{ company.chineseName }}</td>
              </tr>
              <tr v-if="company.type">
                <td max-width="35%" class="text-subtitle-1">Type:</td>
                <td>{{ company.type }}</td>
              </tr>
              <tr v-if="company.email">
                <td max-width="35%" class="text-subtitle-1">Email:</td>
                <td>{{ company.email }}</td>
              </tr>
              <tr v-if="company.officeAddressEng">
                <td max-width="35%" class="text-subtitle-1">
                  Office Address (English):
                </td>
                <td>{{ company.officeAddressEng }}</td>
              </tr>
              <tr v-if="company.officeAddressThai">
                <td max-width="35%" class="text-subtitle-1">
                  Office Address (Thai):
                </td>
                <td>{{ company.officeAddressThai }}</td>
              </tr>
              <tr v-if="company.officePhone1">
                <td max-width="35%" class="text-subtitle-1">Office Phone 1:</td>
                <td>{{ company.officePhone1 }}</td>
              </tr>
              <tr v-if="company.officePhone2">
                <td max-width="35%" class="text-subtitle-1">Office Phone 2:</td>
                <td>{{ company.officePhone2 }}</td>
              </tr>
              <tr v-if="company.factoryAddressEng">
                <td max-width="35%" class="text-subtitle-1">
                  Factory Address (English):
                </td>
                <td>{{ company.factoryAddressEng }}</td>
              </tr>
              <tr v-if="company.factoryAddressThai">
                <td max-width="35%" class="text-subtitle-1">
                  Factory Address (Thai):
                </td>
                <td>{{ company.factoryAddressThai }}</td>
              </tr>
              <tr v-if="company.factoryPhone1">
                <td max-width="35%" class="text-subtitle-1">
                  Factory Phone 1:
                </td>
                <td>{{ company.factoryPhone1 }}</td>
              </tr>
              <tr v-if="company.factoryPhone2">
                <td max-width="35%" class="text-subtitle-1">
                  Factory Phone 2:
                </td>
                <td>{{ company.factoryPhone2 }}</td>
              </tr>
              <tr v-if="company.isoCertifications">
                <td max-width="35%" class="text-subtitle-1">
                  ISO Certifications:
                </td>
                <td>{{ company.isoCertifications }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <div class="d-flex justify-space-between ma-5">
      <v-btn @click="goBack">Back</v-btn>
      <v-btn @click="edit(id)" color="primary">Edit</v-btn>
      <span></span>
    </div>
  </div>
</template>

<script>
import { getCompany } from "@/services/company";

export default {
  data() {
    return {
      id: "",
      company: {},
      loaded: false,
      relations: {},
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    edit(id) {
      this.$router.push({ name: "companyEdit", params: { id: id } });
    },
    setInstance() {
      this.setDependencies().then(() => {
        getCompany(this.id)
          .then((response) => {
            this.company = response.data;
            this.loaded = true;
          })
          .catch(() => {
            this.addErrorMessage("Error loading company");
            this.loaded = true;
          });
      });
    },
    async setDependencies() {
      return null;
    },
    getRelationText(id, relationProperty, relationAttribute) {
      const relationList = this.relations[relationProperty];
      if (relationList) {
        const relationObj = relationList.find((r) => r.id == id);
        return relationObj[relationAttribute];
      } else {
        return "";
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.setInstance();
    this.$emit("showParent", false);
  },
};
</script>
